<template>
  <div>

    <div class="row">
      <div class="col-md-10">
        <div class="form-group">
          <input type="text" class="form-control" v-model="filtros.pesquisa" placeholder="Pesquisa: Entre com NOME ou CÓDIGO do subgrupo" @keyup.enter="filtrar">
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <button @click="filtrar" class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    filters: {

    },
    data: () => ({
      filtros: {
        pesquisa: '',
      },
    }),

    mounted () {

    },

    methods: {
      filtrar: function() {
        this.$emit('filtrar', this.filtros);
      }
    },
    watch: {

    },

    components: {

    }

  }
</script>


// WEBPACK FOOTER //
// filtroContratoSubgrupo.vue?d8885d04